import { QueryKeys, useEntity } from "@/api/core";
import { pollSchema, type Poll } from "@/schemas";

function usePoll(id: string) {
  const { data: poll, ...result } = useEntity<Poll>({
    queryKey: QueryKeys.polls.poll(id),
    endpoint: `/api/v1/polls/${id}`,
    schema: pollSchema,
    id,
  });

  return {
    ...result,
    poll,
  };
}

export { usePoll };
